export default "__VITE_ASSET__BeTk$q3$__";